import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-adaptive-id-dialog',
  template: `
    <h1 mat-dialog-title>Enter Adaptive ID</h1>
    <div mat-dialog-content>
      <mat-form-field>
        <mat-label>Adaptive ID</mat-label>
        <input matInput [(ngModel)]="data.adaptiveId" />
      </mat-form-field>
    </div>
    <div mat-dialog-actions>
      <button mat-button (click)="onCancel()">Cancel</button>
      <button mat-button color="primary" (click)="onSave()">Create Project ID</button>
    </div>
  `,
  standalone: false,
})
export class AdaptiveIdDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<AdaptiveIdDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { adaptiveId: string }
  ) {}

  onCancel(): void {
    this.dialogRef.close();
  }

  onSave(): void {
    this.dialogRef.close(this.data.adaptiveId);
  }
}
